module.exports = __webpack_public_path__ + "static/img/MMZ.e65c2337.png";